<template>
  <div class="iDalgo-Selection">
    <h1 class="iDalgo-Selection__Title">{{ title }}</h1>
    <transition-group name="fade">
      <i-dalgo-section
        v-for="(section, key) in availableSections"
        :key="`selection-${key}`"
        :section="section"
        :sectionNumber="key"
        :sectionSize="sectionSize" />
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import iDalgoSection from '@/components/iDalgo-Section'

export default {
  name: 'iDalgo-Selection',
  components: {
    iDalgoSection
  },
  computed: {
    ...mapGetters({
      sections: 'sections/getSections',
      current: 'sections/getCurrentSection',
      sectionSize: 'sections/getSectionSize',
      title: 'sections/getTitle',
      env: 'app/getEnv',
      isLoading: 'app/isLoading',
      rootURL: 'app/getRootUrl'
    }),
    availableSections () {
      return this.sections.filter((section, index) => index <= this.current)
    }
  },
  async mounted () {
    // Iframe
    if (window.location !== this.rootURL) {
      const paramRegExp = new RegExp(/playerListId=\w{20,}/gm)
      const idInQuery = this.rootURL.match(paramRegExp)
      if (idInQuery) {
        const listId = idInQuery.pop().split('=')[1]
        this.$store.commit('app/ENV_UPDATED', 'sharedLink')
        this.$router.push({ name: 'my-result', params: { id: listId } })
      } else if (localStorage.getItem('playerList.env') === 'result') {
        this.$router.push({ name: 'my-result', params: { id: localStorage.getItem('playerList.id') } })
      } else {
        this.$store.dispatch('sections/getSections', this.$route.params.id)
          .then(() => {
            if (parseInt(this.$route.params.step) !== 1) {
              this.$router.push({ name: 'steps', params: { step: 1 } })
            }
            this.$store.commit('app/LOADING_UPDATED', false)
          })
      }
    } else {
      this.$store.dispatch('sections/getSections', this.$route.params.id)
        .then(() => {
          if (parseInt(this.$route.params.step) !== 1) {
            this.$router.push({ name: 'steps', params: { step: 1 } })
          }
          this.$store.commit('app/LOADING_UPDATED', false)
        })
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Selection {

  &__Title {
    color: #35312E;
    font-family: "source_sans_probold", sans-serif;
    font-size: 35px;
    margin: 0;
    margin-bottom: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/iDalgo-Selection.vue